module.exports = __webpack_public_path__ + "resources/img/img_word_suggestion_jp.ca4203d5cf40e48977750b08e2cd9c16.png";